// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".label--ulayd{margin-left:-1rem;padding:16px 24px;color:#fff;font-weight:600;font-size:14px;line-height:1;letter-spacing:-0.2px}", "",{"version":3,"sources":["webpack://./src/gui/Apps/Customer/Header/DashboardHeaderLabel.module.scss"],"names":[],"mappings":"AAAA,cAAO,iBAAiB,CAAC,iBAAiB,CAAC,UAAU,CAAC,eAAe,CAAC,cAAc,CAAC,aAAa,CAAC,qBAAqB","sourcesContent":[".label{margin-left:-1rem;padding:16px 24px;color:#fff;font-weight:600;font-size:14px;line-height:1;letter-spacing:-0.2px}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": "label--ulayd"
};
export default ___CSS_LOADER_EXPORT___;
